import { ChangeDetectorRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { DevFlag, DevFlagSelectors } from '@recruitee/dev-flags-data';

@Directive({ selector: '[rtDevFlag]' })
export class DevFlagDirective {
  @Input('rtDevFlag') private flag: DevFlag;
  @Input('rtDevFlagElse') private elseTpl: TemplateRef<any>;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.store
      .select(DevFlagSelectors.isEnabled(this.flag))
      .pipe(distinctUntilChanged(), takeUntil(this.ngOnDestroy$))
      .subscribe(enabled => {
        enabled
          ? this.viewContainer.createEmbeddedView(this.templateRef)
          : this.elseTpl
            ? this.viewContainer.createEmbeddedView(this.elseTpl)
            : this.viewContainer.clear();
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
